export enum InventoryStatusEnum {
    SOLD = 'sold',
    UNSOLD = 'unsold',
    REFUNDED = 'refunded',
    RESERVED = 'reserved',
}
